import { useState, useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';

export interface CreateCommunicationInputPayload {
  /** IRI de l'animation parente, ex: "/api/animation_inputs/42" */
  animationInput: string;
  defTitle: string;
  defDescription?: string;
  defChannelId: number;
  defSendStart?: string;
  defNotSendable?: number;
  targetTitle?: string;
  targetDescription?: string;
  targetQueryId?: number;
  creationPayload?: Record<string, unknown>;
}

export interface CommunicationInputCreated {
  id: number;
  defTitle: string;
  defChannelId: number;
  defSendStart: string | null;
  animationInput: { id: number };
}

const useCreateCommunicationInput = () => {
  const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const createCommunicationInput = useCallback(
    async (payload: CreateCommunicationInputPayload): Promise<CommunicationInputCreated | null> => {
      if (!isReady) return null;
      setIsLoading(true);
      setError('');
      try {
        const result: CommunicationInputCreated = await authFetch('/communication_inputs', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/ld+json',
            Accept: 'application/ld+json',
          },
          body: JSON.stringify(payload),
        });
        return result;
      } catch (err: unknown) {
        setError(err instanceof Error ? err.message : 'Erreur lors de la création de la communication');
        return null;
      } finally {
        setIsLoading(false);
      }
    },
    [authFetch, isReady]
  );

  return { createCommunicationInput, isLoading, error };
};

export default useCreateCommunicationInput;
